export default __webpack_public_path__ + "static/media/secondary.c621fd596b11922586171068b65cbdc4.svg";